var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarRental = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Car-Key--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Car Key Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 22h-3a0.5 0.5 0 0 0 -0.5 0.5v0.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-0.5a0.51 0.51 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 22h-3a0.51 0.51 0 0 0 -0.5 0.5v0.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-0.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.32 16.78 -1.63 -1.43a0.23 0.23 0 0 1 -0.07 -0.1l-1.43 -4.09A1.76 1.76 0 0 0 17.54 10H8a1.75 1.75 0 0 0 -1.65 1.17l-1.47 4.08a0.36 0.36 0 0 1 -0.07 0.1l-1.63 1.43a1.26 1.26 0 0 0 -0.43 0.94v2A1.25 1.25 0 0 0 4 21h17.5a1.25 1.25 0 0 0 1.25 -1.25v-2a1.23 1.23 0 0 0 -0.43 -0.97Zm-3.53 -1.89a0.25 0.25 0 0 1 -0.2 0.1H6.91a0.28 0.28 0 0 1 -0.21 -0.1 0.31 0.31 0 0 1 0 -0.23l1 -3a0.26 0.26 0 0 1 0.3 -0.17h9.58a0.24 0.24 0 0 1 0.23 0.17l1.05 3a0.24 0.24 0 0 1 -0.07 0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93 6.15a0.25 0.25 0 0 1 0.24 -0.15h2.33a0.25 0.25 0 0 1 0.25 0.25v0.25a1.5 1.5 0 1 0 3 0v-0.26A0.25 0.25 0 0 1 16 6h1a0.25 0.25 0 0 1 0.25 0.25v0.25a1.5 1.5 0 1 0 3 0v-0.26A0.25 0.25 0 0 1 20.5 6h0.25a1.5 1.5 0 0 0 0 -3H10.17a0.25 0.25 0 0 1 -0.23 -0.16 4.53 4.53 0 1 0 0 3.32ZM3.75 4.51a2 2 0 1 1 2 2 2 2 0 0 1 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarRental);
export default ForwardRef;